export enum ThemeEnum {
	DEFAULT = 'default',
	CNAM = 'cnam',
	AMELI = 'ameli',
	AMELI_PRO = 'ameli-pro',
	COMPTE_AMELI = 'compte-ameli',
	RISQUE_PRO = 'risque-pro',
	COMPTE_ENTREPRISE = 'compte-entreprise'
}

export const THEME_ENUM_VALUES = Object.values(ThemeEnum);
